<template>
	<div class="operation-multiplication-fractions">
		<div class="terms-operation">
			<template v-if="mixed">
				<span :is="mixed_terms"></span>
				<equal-sign></equal-sign>
				<span :is="mixed_to_fractions_terms"></span>
				<equal-sign></equal-sign>
			</template>
			<span :is="terms_operation"></span>
			<equal-sign></equal-sign>
			<span :is="extras"></span>
			<equal-sign></equal-sign>
			<template v-if="!result.isSimplificated">
				<fraction-component :fraction="result"></fraction-component>
				<equal-sign></equal-sign>
				<fraction-component :fraction="result.simplification"></fraction-component>
				<equal-sign></equal-sign>
			</template>
			<fraction-component :fraction="result.simplificated" class="result"></fraction-component>
			<template v-if="result.intVal>=1">
				<equal-sign></equal-sign>
				<span :is="resultIntFractionNotation"></span>
			</template>
		</div>
	</div>
</template>

<script type="text/javascript">
	import Fraction from '../scripts/Fraction';
	const $operations = require('../scripts/variables').operations;
	const $operators = require('../scripts/variables').operators;
	import FractionComponent from '../FractionComponent.vue';
	import BaseExerciseMixin from '../../js/BaseExerciseMixin';
	import EqualSign from '../EqualSign.vue';

	export default{
		name:'operation-multiplication-fractions',
		mixins:[BaseExerciseMixin],
		components:{FractionComponent, EqualSign},
		props:{
			terms:{type:[Array],required:true},
			isMixed:{type:[Boolean],required:false,default:false},
			operator:{type:String,required:false,default:'*'},
		},
		data(){
			return{
				fractions:[],
			};
		},
		created(){
			let fractions=this.terms.map(el=>new Fraction(el));
			this.mixed=fractions.map(el=>el.intVal>=1).reduce((a,b)=>a||b,false);
			this.fractions=this.mixed?fractions.map(el=>new Fraction(el.simplificated)):fractions;
			this.result=$operations.unknow(this.operator,this.fractions);
		},
		methods:{},
		computed:{
			resultIntFractionNotation(){
				return{
					template:this.result.intFractionNotation,
					components:{FractionComponent}
				}
			},
			terms_operation(){
				return {
					template:this.tag('span',this.fractions.join(this.op)),
					components:{FractionComponent},
					name:"terms_operation",
				};
			},
			mixed_terms(){
				return{
					template:this.tag('span',this.fractions.map(el=>el.intVal>=1?el.intFractionNotation:el).join(this.op)),
					components:{FractionComponent},
					name:"mixed_terms",
				}
			},
			mixed_to_fractions_terms(){
				return {
					components:{FractionComponent},
					name:"mixed_to_fractions_terms",
					template:this.tag('span',this.fractions.map(el=>el.mixed_to_fraction_operation).join(this.op))
				};
			},
			extras(){
				return {
					template:this.tag('span',this.result.extras.join(this.tag('equal-sign',''))),
					components:{FractionComponent, EqualSign},
					name:'extras'
				};
			},
			op(){
				return $operators.checkOp_times(this.operator)?' x ':' ÷ ';
			}
		}
	};
</script>